import React from 'react';
import { useSelectionContext } from '../../../contexts/SelectionContext';

import LottieItem from './LottieItem';

const LottieCard = () => {
    const { isItemSelected, selectionList } = useSelectionContext();
    const lottieItems = selectionList.map((selection) => {
        return (
            isItemSelected(selection.topic) && (
                <LottieItem
                    key={`card-item-${selection}`}
                    title={selection.title}
                    text={selection.text}
                    lottieAnimation={selection.lottieAnimation}
                />
            )
        );
    });
    return (
        <div className="card flex flex-col items-center justify-between lg:flex-row lg:space-x-5 lg:items-start lg:w-8/12 xl:w-9/12 min-h-96 overflow-hidden">
            {lottieItems}
        </div>
    );
};

export default LottieCard;
